import { PageLoader } from '@/components/ui/PageLoader'
import { useSealedVinylEntry } from '@/payment/hooks/useSealedVinylEntry'

import { ExitDialog } from './components'
import { LOAD_ERROR_DIALOG } from './lib/constants'
import { SealedVinylFunnel } from './SealedVinylFunnel'

export default function SealedVinylPage() {
  const { isLoading, isError, activeOrderDetail, entryStep, resumeQuantity, resumeSelectedCardId } =
    useSealedVinylEntry()

  if (isLoading) return <PageLoader />
  if (isError) return <ExitDialog {...LOAD_ERROR_DIALOG} />

  return (
    <SealedVinylFunnel
      activeOrderDetail={activeOrderDetail}
      entryStep={entryStep}
      resumeQuantity={resumeQuantity}
      resumeSelectedCardId={resumeSelectedCardId}
    />
  )
}
